import { Vue, Component } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";

// External components
import EditSubscriptionDetails from "@/components/editSubscription/editSubscriptionDetails/editSubscriptionDetails";
import EditSubscriptionTags from "@/components/editSubscription/editSubscriptionTags/editSubscriptionTags";
import EditSubscriptionAddressSchedule from "@/components/editSubscription/editSubscriptionAddressSchedule/editSubscriptionAddressSchedule";
import EditSubscriptionPayment from "@/components/editSubscription/editSubscriptionPayment/editSubscriptionPayment";
import ReactivateSubscription from "@/components/editSubscription/reactivateSubscription/reactivateSubscription";
import AutoGenerateOrders from "@/components/editSubscription/autoGenerateOrders/autoGenerateOrders";
import ModalCancelSubscription from "@/components/modalCancelSubscription/modalCancelSubscription";
import EditUserInfo from "@/components/editSubscription/editUserInfo/editUserInfo";

@Component({
  components: {
    EditSubscriptionDetails,
    EditSubscriptionTags,
    EditSubscriptionAddressSchedule,
    EditSubscriptionPayment,
    ReactivateSubscription,
    AutoGenerateOrders,
    ModalCancelSubscription,
    EditUserInfo,
  },
})
export default class EditSubscription extends Vue {
  @Action action_updateSubscription;

  @Getter getSubscription;
  @Getter getUser;
  @Getter getCity;

  @Mutation SPINNER;

  isShowingTagsModal = false;
  showEditDishModal = false;
  isShowingCancelSubscriptionModal = false;

  mounted() {
    const { isAddingNewDish } = this.$route.query;
    if (isAddingNewDish) {
      this.showEditDishModal = true;
      this.$router.replace({ query: {} });
    }
  }

  logout() {
    localStorage.clear();
    this.$router.go(0);
  }
}
